(ns com.hjsoft.mapmarks.website.ui.marks
  (:require [helix.core :refer [defnc $ <>]]
            [helix.hooks :as hooks]
            [helix.dom :as d]
            [com.hjsoft.mapmarks.website.utils :as utils]
            [com.hjsoft.mapmarks.website.domain.mark :as mark-domain]
            [com.hjsoft.mapmarks.website.state :as state]
            [clojure.string :as str]
            [tick.core :as t]
            [com.hjsoft.mapmarks.website.ui.hooks :as ui-hooks]
            [com.hjsoft.mapmarks.website.ui.layout :refer [mark-notification-toast]]))

(def icon-up-arrow "\u25B2")
(def icon-down-arrow "\u25BC")

(defnc mark-voting
  [{:keys [mark on-vote]}]
  (let [{:keys [score user-vote]} mark
        score (or score 0)
        user-vote (or user-vote 0)]
    (d/div
     {:class "mark-voting"
      :onClick #(.stopPropagation %)}
     (d/button
      {:class (str "vote-btn upvote" (when (= user-vote 1) " active"))
       :onClick #(on-vote 1)
       :title "Upvote"}
      icon-up-arrow)
     (d/span
      {:class (str "vote-score"
                   (cond (pos? score) " positive"
                         (neg? score) " negative"
                         :else ""))}
      score)
     (d/button
      {:class (str "vote-btn downvote" (when (= user-vote -1) " active"))
       :onClick #(on-vote -1)
       :title "Downvote"}
      icon-down-arrow))))

(defnc mark-item
  [{:keys [mark selected? review-mode? on-click on-edit on-delete on-vote
           on-extend item-ref]}]
  (let [[confirming? set-confirming] (hooks/use-state false)
        app-state (state/use-app-state)
        current-user (get-in app-state [:settings :user])
        owner? (mark-domain/mark-owner? mark current-user)
        expired? (utils/past-expiration? (:expiration mark))
        config (:config app-state)
        incomplete? (and owner?
                         (or (not (:disable-name? config))
                             (not (:disable-tags? config)))
                         (if (:disable-name? config)
                           true
                           (empty? (str/trim (or (:name mark) ""))))
                         (if (:disable-tags? config)
                           true
                           (empty? (:tags mark))))]
    (hooks/use-effect
     [selected?]
     (when-not selected?
       (set-confirming false)))
    (d/div
     {:key (mark-domain/mark-key mark)
      :id (str (str/lower-case (:mark-name-singular config)) "=" (:id mark))
      :ref item-ref
      :class (str
              "mark-item"
              (when selected? " selected-mark")
              (when expired? " expired-mark")
              (when incomplete? " incomplete-mark"))
      :onClick on-click}
     ($ mark-notification-toast {:mark-id (:id mark)})
     (d/div
      {:class "mark-content"}
      (when (and (or (:disable-name? config) (not (seq (:name mark))))
                 (or (:disable-tags? config) (not (seq (:tags mark)))))
        (d/div
         {:class "mark-incomplete"}
         "(no details)"))
      (when (and (not (:disable-name? config)) (seq (:name mark)))
        (d/div
         {:class "mark-header"}
         (d/h4 (:name mark))))
      (when (seq (:address mark))
        (d/p (:address mark)))
      (let [town-state (remove empty? [(:town mark) (:state mark)])]
        (when (seq town-state)
          (d/p (str/join ", " town-state))))
      (when (and (not (:disable-tags? (:config app-state))) (seq (:tags mark)))
        (d/div
         {:class "mark-tags"}
         (d/strong (str (:tags-name-plural (:config app-state)) ": "))
         (d/div
          {:class "tags-tags"}
          (map (fn [tag]
                 (d/span
                  {:key tag
                   :class "tag-tag"}
                  tag))
               (filter string? (:tags mark))))))
      (when (seq (:notes mark))
        (d/p
         {:class "mark-notes"}
         (d/strong "Notes: ")
         (:notes mark)))
      (when (and (not selected?) review-mode? (seq (:expiration mark)))
        (d/p
         {:class "expiration-date review-expiration"}
         (d/strong (if expired? "Expired: " "Expires: "))
         (:expiration mark)))
      (when selected?
        (d/div
         {:class "mark-extra-info"}
         ($ mark-voting {:mark mark :on-vote on-vote})
         (d/div
          {:class "mark-extra-fields"}
          (when (and (:lat mark) (:lon mark))
            (d/p {:class "coordinate-text"} (str (:lat mark) ", " (:lon mark))))
          (when (seq (:expiration mark))
            (d/p
             {:class "expiration-date"}
             (d/strong (if expired? "Expired: " "Expires: "))
             (:expiration mark)))
          (when (seq (:updated mark))
            (d/p
             {:class "mark-updated"}
             (d/strong "Last Updated: ")
             (utils/format-timestamp (:updated mark))))
          (when (seq (:creator mark))
            (d/p
             {:class "mark-creator"}
             (d/strong "Created By: ")
             (:creator mark)))
          (d/p
           {:class "mark-shared"}
           (d/strong "Shared: ")
           (if (:shared? mark) "Yes" "No"))))))
     (d/div
      {:class "mark-actions"}

      (when-let [map-link (utils/make-map-link (:lat mark) (:lon mark))]
        (d/a {:href map-link
              :target "_blank"
              :rel "noopener noreferrer"
              :class "go-mark-btn"}
             "Go"))
      (when (and owner? review-mode?)
        (let [days (or (:extend-expiration-days config)
                       (:default-expiration-days config)
                       30)
              handle-extend (fn [e]
                              (.stopPropagation e)
                              (when on-extend (on-extend mark days)))]
          (d/button
           {:class "extend-mark-btn"
            :onClick handle-extend
            :title (str "Extend expiration by " days " days")}
           (str "Extend (+" days "d)"))))
      (when owner?
        (let [handle-edit (fn [e]
                            (.stopPropagation e)
                            (set-confirming false)
                            (on-edit mark))]
          (d/button
           {:class "edit-mark-btn"
            :onClick handle-edit
            :title (str "Edit this " (str/lower-case (:mark-name-singular (:config app-state))))}
           "Edit")))
      (when owner?
        (if confirming?
          (let [handle-delete (fn [e]
                                (.stopPropagation e)
                                (on-delete mark))]
            (d/button
             {:class "delete-mark-btn"
              :onClick handle-delete
              :title (str "Really delete this " (str/lower-case (:mark-name-singular (:config app-state))) "?")}
             "Really?"))
          (let [handle-delete-confirm (fn [e]
                                        (.stopPropagation e)
                                        (set-confirming true))]
            (d/button
             {:class "delete-mark-btn"
              :onClick handle-delete-confirm
              :title (str "Delete this " (str/lower-case (:mark-name-singular (:config app-state))))}
             "Delete"))))))))

(defnc marks-list
  [{:keys [marks]}]
  (let [app-state (state/use-app-state)
        selected-mark (:selected-mark app-state)
        dispatch (state/use-dispatch)
        {:keys [set-editing-mark set-show-form]} (state/use-ui)
        {:keys [delete-mark! vote-mark! extend-mark!]} (ui-hooks/use-actions)
        review-mode? (:review-mode? app-state)
        mark-refs (hooks/use-ref {})]
    (hooks/use-effect
     [selected-mark]
     (when selected-mark
       (when-let [mark-el (get @mark-refs (mark-domain/mark-key selected-mark))]
         (when (fn? (.-scrollIntoView mark-el))
           (.scrollIntoView
            mark-el
            (clj->js {:behavior "smooth" :block "nearest"}))))))

    (d/div
     {:class "marks-list"}
     (if (empty? marks)
       (d/p (if review-mode?
              (str "No "
                   (str/lower-case (:mark-name-plural (:config app-state)))
                   " to review.")
              (str "No "
                   (str/lower-case (:mark-name-plural (:config app-state)))
                   " added yet.")))
       (<>
        (map
         (fn [mark]
           (let [key (mark-domain/mark-key mark)]
             ($ mark-item
                {:key key
                 :mark mark
                 :selected? (= key (mark-domain/mark-key selected-mark))
                 :review-mode? review-mode?
                 :on-click #(dispatch [:set-selected-mark mark])
                 :on-edit #(do
                             (set-editing-mark %)
                             (set-show-form true))
                 :on-extend (fn [m & [d]] (extend-mark! m d))
                 :on-delete #(delete-mark! %)
                 :on-vote #(vote-mark! mark %)
                 :item-ref (fn [el] (swap! mark-refs assoc key el))})))
         marks))))))

(defnc tag-list
  [{:keys [marks]}]
  (let [app-state (state/use-app-state)
        {:keys [tag-filter show-expired? config]} app-state
        dispatch (state/use-dispatch)
        unique-tags (hooks/use-memo
                         [marks]
                         (utils/get-all-unique-tags marks))]
    (when-not (:disable-tags? config)
      (d/div
       {:class "tag-list"}
       (d/div
        {:class "tag-list-content"}
        (d/strong (str (:tags-name-plural config) ": "))
        (if (empty? unique-tags)
          (d/p (str "No " (str/lower-case (:tags-name-plural config)) " available yet."))
          (d/div
           {:class "tags-tags"}
           (map (fn [tag]
                  (d/span
                   {:key tag
                    :class (str
                            "tag-tag"
                            (when (= tag tag-filter)
                              " tag-tag-active"))
                    :onClick #(if (= tag tag-filter)
                                (dispatch [:set-tag-filter nil])
                                (dispatch [:set-tag-filter tag]))}
                   tag))
                unique-tags)))
        (d/div
         {:class "filter-controls"}
         (when (pos? (or (:default-expiration-days config) 0))
           (d/span
            {:class (str "tag-tag show-expired-toggle"
                         (when show-expired? " tag-tag-active"))
             :onClick #(dispatch [:set-show-expired (not show-expired?)])}
            (str "Show Expired " (:mark-name-plural config))))
         (when tag-filter
           (d/button
            {:class "clear-filter-btn"
             :onClick #(dispatch [:set-tag-filter nil])}
            "Clear Filter"))))))))

(defnc review-button []
  (let [app-state (state/use-app-state)
        dispatch (state/use-dispatch)
        config (:config app-state)
        plural (str/lower-case (or (:mark-name-plural config) "marks"))
        review-mode? (:review-mode? app-state)
        recommended? (mark-domain/review-recommended? app-state)]
    (d/button
     {:class (str "review-marks-btn"
                  (when recommended? " review-recommended")
                  (when review-mode? " active"))
      :title (if recommended?
               (str "Review recommended for your " plural)
               (str "Review your " plural))
      :onClick #(dispatch [:set-review-mode (not review-mode?)])}
     (if recommended?
       "Review \u25CF"
       "Review"))))

(defnc review-banner []
  (let [app-state (state/use-app-state)
        dispatch (state/use-dispatch)
        {:keys [config]} app-state]
    (d/div
     {:class "review-banner"}
     (d/span
      {:class "review-banner-text"}
      (str "Reviewing your "
           (str/lower-case (:mark-name-plural config))
           " (sorted by expiration)"))
     (d/button
      {:class "exit-review-btn"
       :onClick #(do
                   (dispatch [:set-last-reviewed (str (t/today))])
                   (dispatch [:set-review-mode false]))}
      "Done Reviewing"))))
